import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { User } from "../models/user.model";
import { LoginParams } from "../params/login-params";

@Injectable({
    providedIn: 'root',
  })

  export class UserService {

    baseUrl!: string;

    constructor(private http: HttpClient) {
        this.baseUrl = environment.apiUrl + '/api';
    }

    getAllUsers(): Observable<User[]> {
        return this.http.get<User[]>(this.baseUrl + '/User');
    }

    getActiveUsers(): Observable<User[]> {
        return this.http.get<User[]>(this.baseUrl + '/User/active');
    }

    getUserById(id: number): Observable<User> {
        return this.http.get<User>(`${this.baseUrl}/User/${id}`);
    }

      getLoggedInUser(): User {
        const userJson = localStorage.getItem('loggedInUser');
        return userJson ? JSON.parse(userJson) : null;
      }

      logout(): void {
        localStorage.removeItem('loggedInUser');
      }
}